<h2 mat-dialog-title>{{ editMode ? "Editar Sesión" : "Crear Sesión" }}</h2>
<mat-dialog-content>
  <form #form class="example-form">
    <!--hora de inicio-->
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Hora de inicio</mat-label>
      <input
        type="time"
        matInput
        format="HH:mm"
        [formControl]="startTime"
        [errorStateMatcher]="matcher"
        maxlength="256"
        placeholder="Ingrese la hora de inicio para la agenda..."
        required
      />
      <mat-hint align="start"><strong></strong></mat-hint>
      <mat-hint align="end">{{ startTime.value.length }} / 256</mat-hint>
      <mat-error *ngIf="startTime.hasError('required')"
        >Hora de inicio <strong>requerido</strong></mat-error
      >
    </mat-form-field>
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Duración <strong>(minutos)</strong></mat-label>
      <input
        matInput
        [formControl]="duration"
        [errorStateMatcher]="matcher"
        type="number"
        maxlength="3"
        min="1"
        onkeydown="javascript: return event.keyCode === 8 ||
      event.keyCode === 46 ? true : !isNaN(Number(event.key))"
        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
        required
      />
      <mat-error *ngIf="duration.hasError('required')"
        >Número <strong>requerido</strong></mat-error
      >
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onSubmit()">
    {{ editMode ? "Guardar" : "Crear" }}
  </button>
  <button mat-button color="primary" (click)="onClose()">Cancelar</button>
</mat-dialog-actions>
